import type {
  ApiResponse,
  QuestionnaireDefinition,
  UpdateStepDefinitionPayload,
} from '@klaro7/shared-types';
import api from '@/lib/api';

export async function getQuestionnaireDefinition(): Promise<QuestionnaireDefinition> {
  const response = await api.get<ApiResponse<QuestionnaireDefinition>>(
    '/questionnaire/admin/definition',
  );
  return response.data.data;
}

export async function updateStepDefinition(
  step: number,
  payload: UpdateStepDefinitionPayload,
): Promise<QuestionnaireDefinition> {
  const response = await api.put<ApiResponse<QuestionnaireDefinition>>(
    `/questionnaire/admin/definition/step/${step}`,
    payload,
  );
  return response.data.data;
}
